/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { SpaceObjectType } from '@ootk/src/main';
import { KM_PER_AU } from 'astronomy-engine';
import { PlanetColors } from './celestial-body';
import { DwarfPlanet } from './dwarf-planet';
import { makemakeEarthSvs } from './makemake-state-vectors';
export var MakemakeTextureQuality;
(function (MakemakeTextureQuality) {
    MakemakeTextureQuality["POTATO"] = "512";
    MakemakeTextureQuality["MEDIUM"] = "2k";
    MakemakeTextureQuality["HIGH"] = "4k";
})(MakemakeTextureQuality || (MakemakeTextureQuality = {}));
export class Makemake extends DwarfPlanet {
    RADIUS = 717;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    orbitalPeriod = 306.70 * 365.25 * 24 * 3600;
    meanDistanceToSun = 45.499 * KM_PER_AU;
    type = SpaceObjectType.DWARF_PLANET;
    eci;
    rotation = [0, 0, Math.PI * 7 / 10];
    color = PlanetColors.MAKEMAKE;
    textureQuality = MakemakeTextureQuality.POTATO;
    svDatabase = {
        [SolarBody.Earth]: makemakeEarthSvs,
        [SolarBody.Sun]: makemakeEarthSvs,
    };
    getName() {
        return 'Makemake';
    }
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/makemake${this.textureQuality}.jpg`;
    }
    useHighestQualityTexture() {
        this.textureQuality = MakemakeTextureQuality.HIGH;
        this.loadTexture();
    }
}
